<template>
  <section class="container-full-5">
    <div class="d-flex align-items-center gap-4 mb-6">
      <button class="btn white2" @click="goBack">
        <img src="/public/icons/icon-back.svg" class="btn-icon" alt="" />
        <span>Retour</span>
      </button>
      <h2 class="secondary-font gap-4 mt-2 mb-0">Membre - Carte</h2>
    </div>

    <div class="clear-both h-0"></div>

    <div v-if="loading" class="flex-center py-10">
      <div class="loader dark"></div>
    </div>

    <div v-if="errorMessage" class="alert alert-danger mb-4">
      {{ errorMessage }}
    </div>

    <!-- User info header -->
    <div v-if="member" class="widget mb-6" style="display: flex; align-items: center; gap: 1.25rem; padding: 1.25rem 1.5rem;">
      <div style="width: 64px; height: 64px; min-width: 64px; flex: 0 0 64px; border-radius: 50%; overflow: hidden;">
        <img :src="member.photo_url ? member.photo_url : '/public/assets/users/300w/user2.jpg'" style="width: 100%; height: 100%; object-fit: cover; display: block;" />
      </div>
      <div style="flex: 1 1 0; min-width: 0;">
        <h4 class="mb-1" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ member.email || member.telephone || 'N/A' }}</h4>
        <p class="text-sm text-grey-700 m-0">{{ member.nom }} {{ member.prenom }}</p>
      </div>
      <div style="flex: 0 0 auto; display: flex; flex-direction: column; gap: 0.5rem; align-items: flex-start;">
        <span class="text-sm font-medium">{{ member.collectivite?.nom || 'N/A' }}</span>
        <span v-if="member.actif" class="tag-state notif stroke">Actif</span>
        <span v-else class="tag-state danger stroke">Inactif</span>
      </div>
      <div style="flex: 1 1 200px; min-width: 200px;">
        <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
          <div class="widget-floating py-0 text-xl flex-right">Solde</div>
          <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" style="width: 100%;">
            {{ selectedCarte ? formatAmount(selectedCarte.solde) + ' F' : '-' }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="cartesLoading" class="text-center py-5 text-grey-500">Chargement des cartes...</div>

    <div v-else-if="cartes.length === 0" class="text-center py-5 text-grey-500">
      Aucune carte associée à ce membre.
    </div>

    <!-- Carte detail -->
    <div v-else-if="selectedCarte" class="s20 widget px-6 pt-8 pb-2 mb-6">
      <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
        <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
          <img src="/public/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
          <img src="/public/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
          Carte
        </span>
      </div>
      <div class="s10 mt--5-5 flex-right gap-3">
        <button
          v-if="selectedCarte.statut !== 'blocked'"
          class="btn-ultra lg shadow-200 color2"
          :disabled="blocking"
          @click="bloquerCarte"
        >
          <div class="btn-show" :class="{ 'display-none': blocking }">
            <img src="/public/icons/icon-consulter.svg" class="btn-icon" alt="" />
            <span>Bloquer</span>
          </div>
          <div class="btn-loading" :class="{ 'display-none': !blocking }">
            <div class="loader-dots"></div>
          </div>
        </button>
        <span v-else class="tag-state danger stroke">Bloquée</span>
      </div>
      <div class="clear-both h-5"></div>

      <div class="s20 items-center gap-6 px-5 pb-6 collapse-content active">
        <!-- Retrait form (si statut delivery) -->
        <div v-if="selectedCarte.statut === 'delivery'" class="rounded-30 mt-3 mb-6" style="background-color: rgba(var(--color-black-rgb), 0.04); padding: 1.5rem;">
          <h4 class="mb-4">Retrait de carte</h4>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 0.75rem;">
            <input v-model="retraitForm.telephone" type="text" class="retrait-input" placeholder="Numéro de téléphone du membre">
            <input v-model="retraitForm.numero_piece" type="text" class="retrait-input" placeholder="Numéro de la pièce d'identité">
            <input v-model="retraitForm.nom" type="text" class="retrait-input" placeholder="Nom">
            <input v-model="retraitForm.bloc4" type="text" class="retrait-input" placeholder="Les 4 derniers chiffres de la carte" maxlength="4">
            <input v-model="retraitForm.prenom" type="text" class="retrait-input" placeholder="Prénom">
            <input v-model="retraitForm.code_retrait" type="text" class="retrait-input" placeholder="Code de retrait de la carte">
          </div>
          <div class="flex-right mt-4">
            <button
              class="btn-ultra"
              style="white-space: nowrap; min-width: 180px;"
              :disabled="retraitLoading"
              @click="retraitCarte"
            >
              <div class="btn-show" :class="{ 'display-none': retraitLoading }" style="white-space: nowrap;">
                <img src="/public/icons/icon-valider.svg" class="btn-icon" alt="" />
                <span style="white-space: nowrap;">Valider le retrait</span>
              </div>
              <div class="btn-loading" :class="{ 'display-none': !retraitLoading }">
                <div class="loader-dots"></div>
              </div>
            </button>
          </div>
        </div>

        <div class="s20 flex gap-5">
          <div class="s6_mobile">
            <img src="/public/images/carte_coop.png" alt="Carte" width="100%" class="rounded-30" />
          </div>
          <div class="flex-center">
            <hr class="hr-vertical h-100p"/>
          </div>
          <div class="s7_mobile px-6">
            <h3 class="font-normal text-primary-color mb-4">
              Carte &nbsp;
              <span v-if="selectedCarte.statut === 'active'" class="tag-state notif stroke">Validé</span>
              <span v-else-if="selectedCarte.statut === 'blocked'" class="tag-state danger stroke">Bloquée</span>
              <span v-else class="tag-state warning stroke">{{ selectedCarte.statut }}</span>
            </h3>
            <h4 class="text-grey-900 my-2">**** **** **** {{ selectedCarte.bloc4 || '****' }}</h4>
            <h4 class="text-grey-900 my-2">{{ selectedCarte.banque?.nom || 'N/A' }}</h4>
            <h5 v-if="selectedCarte.created_at" class="font-normal my-2 text-grey-800">
              Créé le {{ formatDateLong(selectedCarte.created_at) }}
            </h5>
            <div class="clear-both h-10"></div>
            <h4 class="text-grey-800">Référence / {{ selectedCarte.reference || '-' }}</h4>
            <div class="clear-both h-10"></div>
            <h4 class="font-normal mb-2 text-grey-800">Solde disponible</h4>
            <h4 class="mb-2 text-grey-800">{{ formatAmount(selectedCarte.solde) }} F</h4>
          </div>
          <div class="flex-center">
            <hr class="hr-vertical h-100p"/>
          </div>
          <div class="s7_mobile px-6">
            <h3 class="font-normal text-primary-color mb-4">Retrait &nbsp;
              <span v-if="selectedCarte.date_retrait" class="tag-state notif stroke">Effectué</span>
              <span v-else class="tag-state warning stroke">En attente</span>
            </h3>
            <h5 v-if="selectedCarte.date_retrait" class="font-normal my-2 text-grey-800">
              Retiré le {{ formatDateLong(selectedCarte.date_retrait) }}
            </h5>
            <h5 v-else class="font-normal my-2 text-grey-500">Carte non encore retirée</h5>
            <div class="clear-both h-10"></div>
            <h4 v-if="selectedCarte.num_lot" class="text-grey-800">N° de lot : {{ selectedCarte.num_lot }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Transactions -->
    <div v-if="selectedCarte" class="s20 widget px-6 pt-8 pb-2">
      <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
        <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
          <img src="/public/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
          <img src="/public/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
          Transactions
        </span>
      </div>
      <div class="clear-both h-5"></div>

      <div class="s20 gap-6 px-4 pb-6 collapse-content active">
        <div class="s20 flex gap-3 mb-2">
          <div class="form-field-split my-4">
            <div class="form-field-floating reactive search sm">
              <input v-model="txReference" type="text" class="form-input" name="reference" id="reference" placeholder="" @keyup.enter="applyTxFilters">
              <label for="reference">Référence de transaction</label>
            </div>
          </div>
          <div class="form-field-split my-4">
            <div class="form-field-floating reactive sm">
              <input v-model="txDateMin" type="date" class="form-input" name="date_min" id="date_min" placeholder="">
              <label for="date_min">Date >=</label>
            </div>
            <hr class="hr sm" />
            <div class="form-field-floating reactive sm">
              <input v-model="txDateMax" type="date" class="form-input" name="date_max" id="date_max" placeholder="">
              <label for="date_max">Date &lt;=</label>
            </div>
          </div>
          <button class="btn lg shadow-200 color2" @click="applyTxFilters">
            <span>Filtrer</span>
          </button>
        </div>

        <div v-if="transactionsLoading" class="text-center py-5 text-grey-500">
          Chargement des transactions...
        </div>

        <div v-else-if="transactions.length === 0" class="text-center py-5 text-grey-500">
          Aucune transaction trouvée pour cette carte.
        </div>

        <div v-else class="s20">
          <div v-for="tx in transactions" :key="tx.id" class="flex gap-6 mb-4">
            <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
              <img src="/public/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
            </div>
            <div class="s13 mt-2">
              <h6 class="secondary-font font-semibold mb-1">{{ tx.libelle || tx.description || tx.reference || '-' }}</h6>
              <p class="secondary-font text-sm text-grey-600 mb-2">
                {{ formatDateLong(tx.created_at) }}
                <span v-if="tx.reference"> - {{ tx.reference }}</span>
              </p>
            </div>
            <h5 class="s5 secondary-font text-right mt-2" :class="{ 'text-green': tx.type === 'credit' }">
              {{ tx.type === 'credit' ? '+ ' : '- ' }}{{ formatAmount(tx.montant) }} F
            </h5>
          </div>

          <div class="pagination sm justify-content-left mt-5">
            <button class="page-link" :disabled="txPage === 1" @click="changePage(txPage - 1)">
              <img src="/public/icons/icon-pagination-prev.svg" class="pagination-icon" alt="" />
              Précedent
            </button>
            <span class="page-link active">{{ txPage }} / {{ totalPages }}</span>
            <button class="page-link pl-4" :disabled="txPage >= totalPages" @click="changePage(txPage + 1)">
              Suivant
              <img src="/public/icons/icon-pagination-next.svg" class="pagination-icon ml-2" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import membersService from '@/services/membersService'
import { showAlert, showConfirm } from '@/utils/swal'

interface Member {
  id: number
  nom: string
  prenom: string
  collectivite?: { id: number; nom: string }
  photo?: string
  photo_url?: string
  email?: string
  telephone?: string
  actif?: number
}

interface Carte {
  id: number
  alias: string | null
  numero_masque: string | null
  bloc4: string | null
  type: string | null
  statut: string
  solde: number
  expiration_mois: number | null
  expiration_annee: number | null
  reference: string | null
  num_lot: string | null
  date_retrait: string | null
  created_at: string | null
  par_defaut: boolean
  banque: { id: number; nom: string; slug: string } | null
}

interface Transaction {
  id: number
  reference: string | null
  libelle: string | null
  description: string | null
  montant: number
  devise: string | null
  type: string
  statut: string
  categorie_slug: string | null
  created_at: string | null
}

const route = useRoute()
const router = useRouter()
const member = ref<Member | null>(null)
const loading = ref(false)
const errorMessage = ref('')

const cartes = ref<Carte[]>([])
const cartesLoading = ref(false)
const selectedCarteId = ref<number | null>(null)

const transactions = ref<Transaction[]>([])
const transactionsTotal = ref(0)
const transactionsLoading = ref(false)
const txPage = ref(1)
const txPerPage = ref(25)
const txReference = ref('')
const txDateMin = ref('')
const txDateMax = ref('')

const blocking = ref(false)
const retraitForm = ref({
  telephone: '',
  nom: '',
  prenom: '',
  numero_piece: '',
  bloc4: '',
  code_retrait: '',
})
const retraitLoading = ref(false)

const selectedCarte = computed<Carte | null>(() => {
  return cartes.value.find(c => c.id === selectedCarteId.value) || cartes.value[0] || null
})

watch(selectedCarte, (carte) => {
  if (carte?.bloc4) {
    retraitForm.value.bloc4 = `**** **** **** ${carte.bloc4}`
  } else {
    retraitForm.value.bloc4 = ''
  }
})

const totalPages = computed(() => Math.ceil(transactionsTotal.value / txPerPage.value) || 1)

onMounted(async () => {
  const memberId = route.params.id
  if (!memberId) {
    router.push({ name: 'collectivites-membres' })
    return
  }
  await loadMember(Number(memberId))
  await loadCartes(Number(memberId))
})

async function loadMember(id: number) {
  try {
    loading.value = true
    errorMessage.value = ''
    const data = await membersService.getMember(id)
    member.value = data
    retraitForm.value.nom = data?.nom || ''
    retraitForm.value.prenom = data?.prenom || ''
    const kycDocs = (data as any)?.kyc?.kyc_documents || []
    const idDoc = kycDocs.find((d: any) => d?.type_document === 'cni_recto' || d?.type_document === 'passeport')
    retraitForm.value.numero_piece = idDoc?.numero || (data as any)?.numero_piece_identite || ''
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors du chargement du membre'
  } finally {
    loading.value = false
  }
}

async function loadCartes(memberId: number) {
  cartesLoading.value = true
  try {
    const data = await membersService.getMemberCartes(memberId)
    cartes.value = data.cartes || []
    if (cartes.value.length > 0 && selectedCarteId.value === null) {
      selectedCarteId.value = cartes.value[0].id
      await loadTransactions()
    }
  } catch (error: any) {
    console.error('Erreur chargement cartes:', error)
  } finally {
    cartesLoading.value = false
  }
}

async function loadTransactions() {
  if (!member.value || !selectedCarte.value) return
  transactionsLoading.value = true
  try {
    const data = await membersService.getMemberCarteTransactions(
      member.value.id,
      selectedCarte.value.id,
      {
        reference: txReference.value || undefined,
        date_min: txDateMin.value || undefined,
        date_max: txDateMax.value || undefined,
        page: txPage.value,
        per_page: txPerPage.value,
      },
    )
    transactions.value = data.data || []
    transactionsTotal.value = data.total || 0
  } catch (error: any) {
    console.error('Erreur chargement transactions:', error)
  } finally {
    transactionsLoading.value = false
  }
}

async function bloquerCarte() {
  if (!member.value || !selectedCarte.value || blocking.value) return
  const confirmation = await showConfirm(
    'Voulez-vous vraiment bloquer cette carte ?',
    'Confirmation de blocage',
  )
  if (!confirmation) return

  blocking.value = true
  try {
    await membersService.bloquerMemberCarte(member.value.id, selectedCarte.value.id)
    await loadCartes(member.value.id)
    await showAlert.success('Carte bloquée avec succès.', 'Blocage réussi')
  } catch (error: any) {
    await showAlert.error(error.message || 'Erreur lors du blocage.', 'Erreur')
  } finally {
    blocking.value = false
  }
}

async function retraitCarte() {
  if (!member.value || !selectedCarte.value || retraitLoading.value) return
  if (!retraitForm.value.bloc4 || !retraitForm.value.code_retrait || !retraitForm.value.telephone) {
    await showAlert.error('Le téléphone, les 4 derniers chiffres et le code de retrait sont obligatoires.', 'Champs manquants')
    return
  }
  retraitLoading.value = true
  try {
    const bloc4Clean = retraitForm.value.bloc4.replace(/\D/g, '').slice(-4)
    await membersService.retraitMemberCarte(member.value.id, selectedCarte.value.id, {
      bloc4: bloc4Clean,
      code_retrait: retraitForm.value.code_retrait,
      telephone: retraitForm.value.telephone,
    })
    await showAlert.success('Carte retirée avec succès.', 'Retrait réussi')
    retraitForm.value = { telephone: '', nom: '', prenom: '', numero_piece: '', bloc4: '', code_retrait: '' }
    await loadCartes(member.value.id)
  } catch (error: any) {
    await showAlert.error(error.message || 'Erreur lors du retrait.', 'Erreur')
  } finally {
    retraitLoading.value = false
  }
}

function applyTxFilters() {
  txPage.value = 1
  loadTransactions()
}

function changePage(page: number) {
  if (page < 1 || page > totalPages.value) return
  txPage.value = page
  loadTransactions()
}

function goBack() {
  if (member.value) {
    router.push({ name: 'collectivites-membre-detail', params: { id: member.value.id } })
  } else {
    router.push({ name: 'collectivites-membres' })
  }
}

function formatAmount(amount: number): string {
  return new Intl.NumberFormat('fr-FR').format(amount || 0)
}

function formatDateLong(dateString: string | null): string {
  if (!dateString) return '-'
  const monthsFr = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc']
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return '-'
  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')
  return `${String(date.getDate()).padStart(2, '0')} ${monthsFr[date.getMonth()]} ${date.getFullYear()} ${hh}:${mm}`
}
</script>

<style scoped>
.retrait-input {
  width: 100%;
  padding: 0.65rem 1rem;
  font-size: 0.95rem;
  background-color: var(--color-white);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 50px;
  outline: none;
  transition: border-color 0.15s;
}
.retrait-input:focus {
  border-color: var(--primary-color);
}
.retrait-input::placeholder {
  color: rgba(0, 0, 0, 0.4);
}
</style>
